import { Box, Button, Text } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import TextArea from 'modules/core/components/TextArea'
import { Result, UnhandledResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'

import { useGenerateUsingAiForm } from 'modules/performance_process/components/review/show/GenerateUsingAI/useGenerateUsingAiForm'

interface Props {
  onClose: () => void
  onGenerate: (content: string) => Promise<UnhandledResult<Result<unknown>>>
}

export function GenerateUsingAIModal({ onClose, onGenerate }: Props) {
  const form = useGenerateUsingAiForm({ onSuccess: onClose, onGenerate })

  return (
    <Modal
      illustration="lightbulb"
      title={i18n.t('performance_process.reviews.generate_using_ai_modal.title')}
      onClose={onClose}
      onSubmit={() => form.handleSubmit()}
      footer={
        <Box justifyContent="center" alignItems="center" flexDirection="row" gap="s8">
          <Button type="secondary" onClick={onClose} disabled={form.isSubmitting}>
            {i18n.t('common.cancel')}
          </Button>
          <Button submit loading={form.isSubmitting}>
            {i18n.t('performance_process.reviews.generate_using_ai_modal.generate')}
          </Button>
        </Box>
      }
      locked
    >
      <Box gap="s32">
        <Box gap="s8">
          <Text.Normal>
            {i18n.t('performance_process.reviews.generate_using_ai_modal.description')}
          </Text.Normal>
        </Box>
        <Box gap="s24" paddingBottom="s32" maxHeight="s600">
          <TextArea
            aria-label={i18n.t('performance_process.reviews.generate_using_ai_modal.field_label')}
            placeholder={i18n.t(
              'performance_process.reviews.generate_using_ai_modal.field_placeholder'
            )}
            error={form.errors.content}
            value={form.values.content}
            onChange={(value) => form.setFieldValue('content', value)}
            maxHeight="s360"
            mandatory
          />
        </Box>
      </Box>
    </Modal>
  )
}
